export const calculateTotalPosts = (data) => {
  // Sum up all videos across the provided data
  return data.reduce((sum, item) => sum + (item.videos?.length || 0), 0);
};

export const calculateTotalReactions = (data) => {
  // Sum up likes for all videos
  return data.reduce(
    (sum, item) =>
      sum +
      (item.videos?.reduce(
        (videoSum, video) =>
          videoSum +
          (video.videoMetrics?.likeCount || 0) +
          (video.videoMetrics?.commentCount || 0),
        0
      ) || 0),
    0
  );
};

export const calculateTotalViews = (data) => {
  // Sum up view counts from all videos/posts in the dataset.
  // Checks for both videoMetrics.viewCount (YouTube) and postMetrics.views (General Post/Instagram/Facebook).
  return data.reduce(
    (sum, item) =>
      sum +
      (item.videos?.reduce(
        (videoSum, video) =>
          videoSum +
          (video.videoMetrics?.viewCount || 0) +
          (video.postMetrics?.views || 0),
        0
      ) || 0),
    0
  );
};

export const calculateTotalImpressions = (data) => {
  if (!Array.isArray(data)) {
    return 0;
  }
  return data.reduce(
    (sum, item) => sum + (item.channelMetrics?.views || 0),
    0
  );
};

export const calculateTotalReach = (data) => {
  if (!Array.isArray(data)) {
    return 0;
  }

  // Estimate reach based on impressions (divide by 1.5)
  // Since we don't have unique viewers, this acts as a proxy
  const totalImpressions = calculateTotalImpressions(data);
  return Math.round(totalImpressions / 1.3);
};